export type STimePickerSize = 'sm' | 'md';
export type STimePickerType = 'default' | 'midday';
export type STimePickerMeridiem = 'AM' | 'PM';

const V = (path: string) => `var(--cmp-timepicker-${path})`;

export const TIMEPICKER_SIZES = ['sm', 'md'] as const;

export const TIMEPICKER_SIZE_CONFIG: Record<
  STimePickerSize,
  {
    height: string;
    paddingX: string;
    gap: string;
    icon: string;
    radius: string;
    fontSize: number;
    lineHeight: number;
    minWidth: number;
    fieldMinWidth: number;
  }
> = {
  sm: {
    height: V('sm-height'),
    paddingX: V('sm-paddingX'),
    gap: V('sm-gap'),
    icon: V('sm-icon'),
    radius: V('sm-radius'),
    // TODO: component.timepicker 토큰에 typography가 추가되면 CSS 변수로 교체한다.
    fontSize: 12,
    lineHeight: 20,
    minWidth: 80,
    fieldMinWidth: 128,
  },
  md: {
    height: V('md-height'),
    paddingX: V('md-paddingX'),
    gap: V('md-gap'),
    icon: V('md-icon'),
    radius: V('md-radius'),
    // TODO: component.timepicker 토큰에 typography가 추가되면 CSS 변수로 교체한다.
    fontSize: 14,
    lineHeight: 24,
    minWidth: 96,
    fieldMinWidth: 160,
  },
};

export function clampTimePart(value: number, min: number, max: number): number {
  if (!Number.isFinite(value)) return min;
  return Math.min(Math.max(value, min), max);
}

export function padTimePart(value: number): string {
  return String(value).padStart(2, '0');
}

export function parseTimeValue(value: string | null | undefined): {
  hour: number;
  minute: number;
} {
  const match = /^(\d{1,2}):(\d{1,2})$/.exec(value ?? '');
  if (!match) return { hour: 0, minute: 0 };
  return {
    hour: clampTimePart(Number(match[1]), 0, 23),
    minute: clampTimePart(Number(match[2]), 0, 59),
  };
}

export function formatTimeValue(hour: number, minute: number): string {
  return `${padTimePart(clampTimePart(hour, 0, 23))}:${padTimePart(clampTimePart(minute, 0, 59))}`;
}

export function formatTimeDisplay(value: string | null | undefined, type: STimePickerType): string {
  if (value == null || value === '') return '';
  const { hour, minute } = parseTimeValue(value);
  if (type === 'default') return formatTimeValue(hour, minute);

  const meridiem = hour >= 12 ? '오후' : '오전';
  const displayHour = hour % 12 === 0 ? 12 : hour % 12;
  return `${meridiem} ${padTimePart(displayHour)}:${padTimePart(minute)}`;
}
